<template>
  <div class="select-adicionar-campos">
    <div class="container-search">
      <i class="fa fa-search icn-search"></i>
      <input
        type="text"
        class="ipt-search"
        placeholder="Busque pelo campo"
        v-model="search"
      />
    </div>
    <div class="container-items">
      <div v-for="(campo, index) in camposFiltrados" :key="index" class="item" @click="handleClickElemenToChecked(campo.filtro)">
        <tool-tip 
          tag="input"
          @click.stop
          :texto="campo.default ? 'Este é um campo padrão do filtro, então não pode ser desabilitado.' : ''"
          placement="bottom"
          data-custom-class="custom-maino-tooltip"
          type="checkbox"
          :name="campo.filtro"
          :id="`${campo.filtro}_filtro`"
          :value="campo.filtro"
          class="custom-checkbox"
          :checked="filtros.some(c => c.filtro === campo.filtro)"
          :disabled="campo.default"
        />
        <span>{{ campo.name }}</span>
      </div>
    </div>
    <div class="container-button-aplicar">
      <button @click="salvar" class="btn btn-maino">Salvar</button>
    </div>
  </div>
</template>
<script>
import ToolTip from '../../../../helpers/ToolTip.vue';
export default {
  components: {
    ToolTip,
  },
  props: {
    filtrosSelecionados: {
      type: Array,
      required: true
    },
    filtros: {
      type: Array,
      required: true
    },
    campos: {
      type: Array,
      required: true
    }
  },
  emits: ['adicionarFiltro', 'close'],
  data() {
    return {
      itemsChecked: [],
      search: ''
    }
  },
  computed: {
    camposFiltrados() {
      return this.campos.filter(campo => {
         const name = this.$removeAccents(campo.name.toLowerCase())
         const search = this.$removeAccents(this.search.toLowerCase())
         return name.includes(search)
     });
    }
  },
  methods: {
    salvar() {
      document.querySelectorAll('.select-adicionar-campos .container-items .item input').forEach(item => {
        if (item.checked) {
          this.itemsChecked.push(this.campos.find(campo => campo.filtro === item.value));
        }
      });
      this.$emit('adicionarFiltro', this.itemsChecked);
      this.$emit('close');
      this.itemsChecked = [];
    },
    handleClickElemenToChecked(filtro) {
      const checkbox = document.getElementById(`${filtro}_filtro`);
      if (checkbox.disabled) return;
      checkbox.checked = !checkbox.checked;
    }
  },
  mounted() {
    document.addEventListener('click', (event) => {
      if (!event.target.closest('.select-adicionar-campos') && !event.target.closest('.container-btn-adicionar-filtro')) {
        this.$emit('close');
      }
    });
  }
}
</script>
